import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { isMobile } from "react-device-detect";

const ResultMsg = (props) => {
  const { t } = props;

  const genders = JSON.parse(sessionStorage.getItem("genderFilterList"));
  const origins = JSON.parse(sessionStorage.getItem("originFilterList"));

  return (
    props.searchtext != "" && <>
      <p className="sorry-text">{t("BabyNameFinder_SorryLabel")}!</p>
      {props.totalCount !== 0 ? (
        <p className="sorry-message-text">
          {props.similarResultMessage != false ?
            props.similarResultMessage
              .replace("{searchTerm}", `${props.searchtext}`)
              .replace("{resultCount}", props.totalCount)
              : ""
            }
        </p>
      ) : props.totalCount === 0 &&
        ((genders && genders.length > 0) || (origins && origins.length > 0)) ? (
        <p className="sorry-message-text">
          Sorry, we dont have any results for the chosen filter criteria
        </p>
      ) : (
        <p className="sorry-message-text">
          {props.noResultMessage.replace("{searchTerm}", `${props.searchtext}`)}
        </p>
      )}
      {/* {props.totalCount === 0 &&
                <p className="sorry-message-text">{props.noResultMessage.replace('{searchTerm}', `${props.searchtext}`)}</p>
            } */}
      {/* {props.totalCount === 0 && (genders && genders.length > 0 || origins && origins.length > 0) ? <p className="sorry-message-text">
                Sorry, we dont have any results for the chosen filter criteria
            </p> : null

            } */}
    </>
  );
};

export default withTranslation()(ResultMsg);
